module.exports = __webpack_public_path__ + "static/media/Kerstmenu.13bf774a.pdf";